import React from 'react'
import { Link } from 'react-router-dom'
import insightsIcon from '../assets/images/insights-dark.png'
import { Default, Mobile } from '../utils/responsive'
import config from '../config'

import './Header.css'

const UserDropdown = ({ displayName, toggleMenu, isActive }) => {
    if (!displayName) return null
    const icon = isActive ? 'fa-chevron-up' : 'fa-chevron-down'
    return (
        <div className="menu" onClick={toggleMenu}>
            <i className="fa fa-user user-detail" />
            <span className="user-detail">{displayName}</span>
            <i className={`user-detail fa ${icon}`} />
        </div>
    )
}

const AppsButton = () => (
    <div>
        <a
            href={config.APPS_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="fa fa-th" />
        </a>
    </div>
)

const MenuDropDown = ({ toggleMenu }) => (
    // eslint-disable-next-line
    <div
        className="menu"
        style={{ paddingLeft: 20, paddingBottom: 2 }}
        onClick={toggleMenu}
    >
        <i className="fa fa-bars" />
    </div>
)

const Header = props => {
    const { logout, isActive, closeMenu, navigationItems } = props

    return (
        <div className="header-container">
            <div className="header">
                <Default>
                    <div className="app">
                        <Link to="/">
                            <img alt="Oztix" src={config.BRAND_ASSETS.Cobrand.PrimaryLogo3Url + "?width=115"} 
                                 className="logo" width="115" />                            
                        </Link>
                        <div className="divider" />
                        <div>
                            <img alt="Insights" title="Insights" src={insightsIcon} className="icon"
                                 width="40" height="40" />
                        </div>
                        <div className="title" style={{ marginRight: 10 }}>
                            Insights
                        </div>
                    </div>
                </Default>
                <Mobile>
                    <Link to="/">
                        <img alt="Oztix" src={config.BRAND_ASSETS.Cobrand.IconLogo3Url + "?width=72"} 
                             className="logo" width="36" height="36" />
                    </Link>
                    <div>
                        <img  alt="Insights" title="Insights" src={insightsIcon} className="icon"
                              width="40" height="40" />
                    </div>
                </Mobile>
                <div style={{ flex: 1, padding: '0 15px' }}>
                    {props.search && props.search}
                </div>
                <Default>
                    <div className="flex" style={{ height: '100%' }}>
                        <div className="nav-items">
                            {navigationItems.map(item => (
                                // eslint-disable-next-line
                                <div
                                    key={item.name}
                                    className={`nav-item ${
                                        item.active ? 'active' : ''
                                    }`}
                                >
                                    <Link to={item.link}>{item.name}</Link>
                                </div>
                            ))}
                        </div>
                        <AppsButton />
                        <UserDropdown {...props} />
                    </div>
                </Default>
                <Mobile>
                    <div className="flex">
                        <AppsButton />
                        <MenuDropDown {...props} />
                    </div>
                </Mobile>
            </div>
            <Default>
                <div style={!isActive ? { display: 'none' } : {}}>
                    <div className="active-menu">
                        <ul>
                            {
                                // eslint-disable-next-line
                                <li className="clickable" onClick={logout}>
                                    Sign out
                                </li>
                            }
                            <li className="clickable">
                                <span style={{ color: 'white' }}>
                                    Version: {config.APPLICATION_VERSION}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="close-menu" onClick={closeMenu} />
                </div>
            </Default>
            <Mobile>
                <div style={!isActive ? { display: 'none' } : {}}>
                    <div className="active-menu">
                        <ul>
                            {navigationItems.map(item => (
                                // eslint-disable-next-line
                                <li key={item.name} className="clickable">
                                    <Link to={item.link}>
                                        <span style={{ color: 'white' }}>
                                            {item.name}
                                        </span>
                                    </Link>
                                </li>
                            ))}
                            {
                                // eslint-disable-next-line
                                <li className="clickable" onClick={logout}>
                                    Sign out
                                </li>
                            }
                            <li className="clickable">
                                <span style={{ color: 'white' }}>
                                    Version: {config.APPLICATION_VERSION}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="close-menu" onClick={closeMenu} />
                </div>
            </Mobile>
        </div>
    )
}

export default Header
